import { NativeCurrencies } from "@/shared/constants";
import { useWeb3State } from "@/web3/context";
import { useQuery } from "@tanstack/react-query";
import useERC20Contract from "../contracts/ERC20/useERC20Contract";

const useERC20AllowanceQuery = (
  userAddress?: string | null,
  operator?: string,
  tokenAddress?: string,
) => {
  const { chainId } = useWeb3State();

  const erc20Contract = useERC20Contract(tokenAddress);

  const { data: allowance, isLoading } = useQuery({
    queryKey: [
      "erc20-allowance",
      tokenAddress,
      erc20Contract,
      chainId,
      userAddress,
      operator,
    ],
    queryFn: async () => {
      if (
        !erc20Contract ||
        !tokenAddress ||
        NativeCurrencies.includes(tokenAddress)
      ) {
        return BigInt(0);
      }

      const allowance = await erc20Contract!.allowance(userAddress, operator);

      return BigInt(allowance);
    },
    enabled: !!(chainId && erc20Contract),
  });

  return {
    allowance,
    isAllowanceLoading: isLoading,
  };
};

export default useERC20AllowanceQuery;
